import { Component, ElementRef } from '@angular/core';
import { cloneDeep } from 'lodash';
import { environment } from 'src/environments/environment';
import { ComponentsService } from '../../services/components.service';
import { AttributeDataService } from '../../services/attribute-data.service';
import { TemplateEditorUtilsService } from '../../services/template-editor-utils.service';
import { WorldTimezonesService } from '../services/world-timezones.service';

@Component({
  selector: 'template-component-layout-time',
  templateUrl: './layout-time.component.html',
  styleUrls: ['./layout-time.component.scss'],
  standalone: false,
})
export class LayoutTimeComponent {
  LayoutType = ComponentsService.LAYOUTS_MAP['rise-layout-time']; // make layout types available in template

  public WORLD_TIMEZONES = WorldTimezonesService.WORLD_TIMEZONES;

  public componentId: string;
  public layout: string;
  public timeFormat: string;
  public timezone: string;
  public color: string;
  private componentLayout: any;
  private componentServices: any;

  constructor(
    private elementRef: ElementRef,
    private componentsService: ComponentsService,
    private attributeDataService: AttributeDataService,
    private templateEditorUtils: TemplateEditorUtilsService,
  ) {
    this.componentsService.registerDirective({
      type: 'rise-layout-time',
      element: this.elementRef.nativeElement,
      show: (options?) => {
        if (this.componentsService.selected?.id) {
          this.componentId = this.componentsService.selected.id;
          this.load();
        }
      },
      getLabel: (componentId: string): string => {
        return 'Time';
      },
      getName: (componentId: string): string => {
        return 'Time';
      },
    });
  }

  load() {
    const defaultAttributes =
      this.componentsService.getSelectedDirective().defaultAttributes;
    const defaultLayout = cloneDeep(defaultAttributes?.layout || {});
    const defaultServices = cloneDeep(defaultAttributes?.services || []);

    const componentLayout =
      this.attributeDataService.getAvailableAttributeData(
        this.componentId,
        'layout',
      ) || defaultLayout;
    const componentServices =
      this.attributeDataService.getAvailableAttributeData(
        this.componentId,
        'services',
      ) || defaultServices;

    // account for situation when "layout" is set as JSON string in html template
    this.componentLayout = this.templateEditorUtils.safeParseJson(
      componentLayout,
      defaultLayout,
    );
    this.componentServices = this.templateEditorUtils.safeParseJson(
      componentServices,
      defaultServices,
    );

    const layoutAttributes = this.componentLayout?.attributes || {};

    this.layout = this.componentLayout.layoutId || this.LayoutType.DIGITAL;
    this.timeFormat = layoutAttributes.timeFormat || 'Hours12';
    this.timezone = layoutAttributes.timezone || '';
    this.color = layoutAttributes.color || 'rgba(125,125,125,1)';

    // if environment is not defined, then this is a new component
    // re-save all setting including environment
    const componentEnvironment = this.attributeDataService.getAttributeData(
      this.componentId,
      'environment',
    );
    if (!componentEnvironment) {
      this.save();
    }
  }

  save() {
    this.componentLayout.layoutId = this.layout;
    this.componentLayout.attributes = {
      timeFormat: this.timeFormat,
      timezone: this.timezone,
      color: this.color,
    };

    if (
      !Array.isArray(this.componentServices) ||
      this.componentServices.length === 0
    ) {
      this.componentServices = [{}];
    }
    this.componentServices[0].attributes = {
      type: 'time',
      time: this.timeFormat,
      timezone: this.timezone,
    };

    this.attributeDataService.setAttributeData(
      this.componentId,
      'layout',
      this.componentLayout,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'services',
      this.componentServices,
    );
    this.attributeDataService.setAttributeData(
      this.componentId,
      'environment',
      environment.production ? 'prod' : 'test',
    );
  }

  setTimeFormat(format: string) {
    this.timeFormat = format;
    this.save();
  }
}
